import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    message: {
      maxWidth: 279,
      margin: [0, "auto"],
      fontSize: theme.typography.large.fontSize,
      textAlign: "center",
      overflowWrap: "break-word",
      [theme.breakpoints.up("mobile")]: {
        maxWidth: 513,
      },
    },
    messageOwner: {
      display: "block",
      border: "none",
      background: "none",
      outline: "none",
      cursor: "pointer",
      transition: "transform 0.1s cubic-bezier(0.61, 1, 0.88, 1)",
      "&:hover": {
        transform: "scale(1.1)",
      },
    },
    messageText: {
      padding: [15, 0],
    },
  }),
  { name: "MakeMessage" },
);
